import { Banner, CommonAllObjectsQuery, FilterOps, GQL_ID, QueryVariablesTypes } from '@@types'
import { useQuery, WatchQueryFetchPolicy } from '@apollo/client'
import { useMemo } from 'react'

import { GQL_QUERY_ALL_BANNERS } from '@entities/Banners/model/queries'

import { IMAGE_SIZES, ImageSize } from '@shared/contants'


type useSingleBannerParams = {
  id?: GQL_ID | null;
  style?: ImageSize;
  mobileSlideStyle?: ImageSize;
  fetchPolicy?: WatchQueryFetchPolicy
}

type AllBannersVariablesTypes = QueryVariablesTypes & {
  style?: string
  bannerMobileSlideStyle2?: string
}

export function useFetchSingleBanner ({
  id,
  style = IMAGE_SIZES.HERO,
  mobileSlideStyle = IMAGE_SIZES.MOBILE,
  fetchPolicy = 'cache-and-network',
}: useSingleBannerParams) {
  const { data, loading, error } = useQuery<CommonAllObjectsQuery<'allBanners', Banner>, AllBannersVariablesTypes>(
    GQL_QUERY_ALL_BANNERS,
    {
      variables: {
        pager: { limit: 1, page: 1 },
        style,
        bannerMobileSlideStyle2: mobileSlideStyle,
        filter: {
          fields: [ 'id' ],
          op: FilterOps.EQUAL,
          value: id
        },
      },
      fetchPolicy,
      skip: !id
    }
  )

  const banner = useMemo(() => data?.allBanners?.edges?.[0] ?? null, [ data ])

  return { 
    data, 
    banner,
    loading, 
    error
  }
}